export default __webpack_public_path__ + "static/media/h5-section1-pic1.13b2dd9b.png";